import { render, staticRenderFns } from "./VueTypeaheadBootstrap.vue?vue&type=template&id=bf3ba51e&scoped=true&"
import script from "./VueTypeaheadBootstrap.vue?vue&type=script&lang=js&"
export * from "./VueTypeaheadBootstrap.vue?vue&type=script&lang=js&"
import style0 from "./VueTypeaheadBootstrap.vue?vue&type=style&index=0&id=bf3ba51e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf3ba51e",
  null
  
)

export default component.exports